import React, { useState, useEffect } from 'react'

export function HrFeedback(props) {



    const bindhrInfo = () => {
        return (
            <>
                {/* {props.HrFeedback ?
                <> <textarea maxLength={3000} onChange={(e) => { props.onSubmit({hrFeedback: e.target.value, hrId: props.Details.roleId }, "hrManager") }} className="form-control hive-form-control touchbase-comments" id="teammember-feedback" placeholder="Enter Here" rows={3} defaultValue={props.HrFeedback} />
                    <p className="text-end font-12 medium-text touchbase-submitted-color">Submitted by {props.Details.name}</p> </> :
                <><textarea maxLength={3000} onChange={(e) => { props.onSubmit({hrFeedback: e.target.value, hrId: props.Details.roleId }, "hrManager") }} className="form-control hive-form-control touchbase-comments" id="teammember-feedback" placeholder="Enter Here" rows={3} defaultValue={""} />
                </>} */}

                <>
                    <textarea maxLength={3000} onChange={(e) => { props.onSubmit({ hrFeedback: e.target.value, hrId: props.Details.roleId }, "Hr Manager") }} className="form-control hive-form-control touchbase-comments" id="teammember-feedback" placeholder="Enter Here" rows={3} defaultValue={props.HrFeedback} />
                    <p className="text-end font-12 medium-text touchbase-submitted-color">Submitted by {props.Details.name}</p> </>

            </>
        )
    }

    const bindempInfo = () => {
        return (
            <>{props.HrFeedback !== undefined ?
                <> <p className="font-12 medium-text touchbase-feedback-text">{props.HrFeedback}</p>
                    <p className="text-end font-12 medium-text touchbase-submitted-color">Submitted by {props.HrFeedbackBy}</p> </> :
                <><textarea className="form-control hive-form-control touchbase-comments" id="teammember-feedback" disabled placeholder="Enter Here" rows={3} defaultValue={props.HrFeedback} /></>}
            </>
        )
    }

    return (
        <>
            {props.HrFeedback != '' &&
            props.Details.role === 'Hr Manager' &&
            props?.HrFeedbackById == props.Details.roleId &&
            props?.status != 'Completed'
                ? bindhrInfo()
                : (props.HrFeedback == undefined || props.HrFeedback == '') &&
                  props.Details.role === 'Hr Manager' &&
                  props?.status != 'Completed'
                ? bindhrInfo()
                : bindempInfo()}
        </>
    );
}
